import { render, staticRenderFns } from "./filter-box.vue?vue&type=template&id=0574b335&scoped=true&"
import script from "./filter-box.vue?vue&type=script&lang=js&"
export * from "./filter-box.vue?vue&type=script&lang=js&"
import style0 from "./filter-box.vue?vue&type=style&index=0&id=0574b335&prod&lang=less&"
import style1 from "./filter-box.vue?vue&type=style&index=1&id=0574b335&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0574b335",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {SvgIcon: require('/app/components/svgIcon/svgIcon.vue').default})
